import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { PageErrorBoundary } from '@/app/components/PageErrorBoundary';
import { CommandMenu } from '@/command-menu/components/CommandMenu';
import { CommandMenuHotkeyEffect } from '@/command-menu/effect-components/CommandMenuHotkeyEffect';
import { DemoBanner } from '@/demo-account/components/DemoBanner';
import { AppNavigationDrawer } from '@/navigation/components/AppNavigationDrawer';
import { NavigationHotkeyEffects } from '@/navigation/components/NavigationHotkeyEffects';
import { AppFrame } from '@/ui/layout/app-frame/components/AppFrame';
import { PageLoadingFallback } from '@/ui/layout/page/components/PageLoadingFallback';

export const AppLayout = () => (
  <>
    <CommandMenuHotkeyEffect />
    <NavigationHotkeyEffects />
    <AppFrame navigationDrawer={<AppNavigationDrawer />}>
      <DemoBanner />
      <PageErrorBoundary>
        <Suspense fallback={<PageLoadingFallback />}>
          <Outlet />
        </Suspense>
      </PageErrorBoundary>
    </AppFrame>
    <CommandMenu />
  </>
);
